import * as yup from "yup";

export const AddPayoutMethodValidation = yup.object().shape({
  account_type: yup
    .string()
    .required("Please choose account type.")
    .oneOf(["bank_account", "vpa"]),
  bank_account: yup.object().when("account_type", {
    is: "bank_account",
    then: yup.object().shape({
      name: yup.string().required("Please enter bank name."),
      ifsc: yup.string().required("Please enter ifsc code."),
      account_number: yup.string().required("Please enter account number."),
    }),
  }),
  vpa: yup.object().when("account_type", {
    is: "vpa",
    then: yup.object().shape({
      address: yup.string().required("Please enter UPI ID"),
    }),
  }),
});
